<div class="tenant-form-wrapper">
  <!-- form -->
  <form [formGroup]="form" class="tenant-form" *ngIf="form">
    <!-- name -->
    <app-form-input-text [field]="'name'" [formControl]="f['name']" formControlName="name"></app-form-input-text>
    <!-- nickname -->
    <app-form-input-text [field]="'nickname'" [formControl]="f['nickname']" formControlName="nickname"></app-form-input-text>
    <!-- email -->
    <app-form-input-text [field]="'email'" [formControl]="f['email']" formControlName="email"></app-form-input-text>
    <div>
      <!-- phone -->
      <app-form-input-text-group [field]="'phone'" [formControl]="f['phone']" formControlName="phone"
        [pre]="'+34'" [preIcon]="'flag-icon flag-es'" [label]="'field.phone' | translate"></app-form-input-text-group>
      <!-- phoneWhatsapp -->
      <app-form-input-text-group [field]="'whatsapp'" [formControl]="f['phoneWhatsapp']" formControlName="phoneWhatsapp"
        [pre]="'+34'" [preIcon]="'flag-icon flag-es'" [label]="'field.whatsapp' | translate"></app-form-input-text-group>
    </div>
    <!-- website -->
    <app-form-input-text [field]="'website'" [formControl]="f['website']" formControlName="website"></app-form-input-text>
    <!-- address -->
    <app-form-input-text [field]="'address'" [formControl]="f['address']" formControlName="address"></app-form-input-text>
    <!-- city -->
    <app-form-input-text [field]="'city'" [formControl]="f['city']" formControlName="city"></app-form-input-text>
    <div>
      <!-- state -->
      <app-form-input-text [field]="'state'" [formControl]="f['state']" formControlName="state"></app-form-input-text>
      <!-- zipcode -->
      <app-form-input-text [field]="'zipcode'" [formControl]="f['zipcode']" formControlName="zipcode"></app-form-input-text>
    </div>
    <!-- legalcode -->
    <app-form-input-text [field]="'legalcode'" [formControl]="f['legalcode']" formControlName="legalcode"></app-form-input-text>
    <div>
      <!-- bankName -->
      <app-form-input-text [field]="'bankName'" [formControl]="f['bankName']" formControlName="bankName"></app-form-input-text>
      <!-- bankSWIFT -->
      <app-form-input-text [field]="'bankSWIFT'" [formControl]="f['bankSWIFT']" formControlName="bankSWIFT"></app-form-input-text>
      <!-- bankAccount -->
      <app-form-input-text [field]="'bankAccount'" [formControl]="f['bankAccount']" formControlName="bankAccount"></app-form-input-text>
    </div>
    <!-- emailBilling -->
    <app-form-input-text [field]="'emailBilling'" [formControl]="f['emailBilling']" formControlName="emailBilling"></app-form-input-text>
    <!-- invoiceSeries -->
    <app-form-input-text [field]="'invoiceSeries'" [formControl]="f['invoiceSeries']" formControlName="invoiceSeries"></app-form-input-text>
    <!-- taxSpecialReason -->
    <app-form-input-text [field]="'taxSpecialReasonInfo'" [formControl]="f['taxSpecialReason']" formControlName="taxSpecialReason"></app-form-input-text>
  </form>
  <!-- buttons -->
  <div class="buttons">
    <p-button [label]="'button.cancel' | translate" severity="secondary" (click)="cancel()"/>
    <p-button [label]="'button.save' | translate" severity="contrast" (click)="save()"/>
  </div>
</div>
    